import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {format} from 'date-fns';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {yupResolver} from '@hookform/resolvers';
import SelectList from '../../components/FormFields/Select';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import SelectInfinite from "../../components/FormFields/SelectInfinite";
import {useUserContext} from "../../contexts/UserContext";
import roles from "../../utils/roles";
import FormatList from "./reportForm/components/format/FormatList";
import {
    controlAssessmentOptions,
    purposeOptions,
    controlTypeOptions,
    controlFrequencyOptions
} from "../../utils/controlsConstants";
import {appModules} from '../../utils/const';

const ControlsReport = () => {
    const lang = getLanguage();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState();
    const [format2, setFormat2] = useState('');

    const user = useUserContext();

    const isValidType = '';

    const schema = yup.object().shape({
        findingStatus: yup
            .object()
            .required(t('message.fieldRequired'))
    });

    const methods = useForm({
        resolver: yupResolver(schema),
    });
    const {watch, errors, formState, getValues, setError, clearErrors, setValue} = methods;

    let validTo = watch('endDate');
    let validFrom = watch('startDate');
    let purpose = watch('purpose');
    let controlAssessment = watch('controlAssessment');
    let frequency = watch("frequency");
    let type = watch('type');
    const department = watch("department");

    const higherRoles = [roles.role_super_admin, roles.role_admin, roles.role_head_of_internal_audit, roles.role_internal_auditor];
    const shouldShow = user.authorities.some(role => higherRoles.includes(role));

    return (<div className="revisions-reports-page content">
        <FormProvider {...methods}>
            <div className="report-form-container" key={window.location.pathname}>
                <div className="row ml-0 mr-0">
                    <div className="form-group pr-5">
                        <label className="label" htmlFor="startDate">
                            {t('reports.dateFrom')}
                        </label>
                        <InputDate
                            name="startDate"
                            maxDate={validTo}
                            defaultValue={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                            className={`date-height form-control ${validTo === null && isSubmitted === true ? `error-field` : ''}`}
                            isClearable={false}
                            placeholderText={t('reports.dateFrom')}
                        />
                        {validFrom === null && isSubmitted === true ? (
                            <span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>) : ('')}
                    </div>
                    <div className="form-group pr-5">
                        <label className="label" htmlFor="endDate">
                            {t('reports.dateTo')}
                        </label>
                        <InputDate
                            name="endDate"
                            minDate={validFrom}
                            defaultValue={new Date()}
                            className={`date-height form-control ${validTo === null && isSubmitted === true ? `error-field` : ''}`}
                            isClearable={false}
                            placeholderText={t('reports.dateTo')}
                        />
                        {validTo === null && isSubmitted === true ? (<span className="error-message position-absolute">
                  {t('message.fieldRequired')}
                </span>) : ('')}
                    </div>
                    <div className="form-group pr-5">
                        <label className="label w-100">
                            {t('controls.purposeLabel')}
                        </label>
                        <SelectList
                            name="purpose"
                            className="select"
                            options={purposeOptions}
                            placeholder={t('controls.purposePlaceholder')}
                            isClearable={true}
                            errors={errors}
                        />
                    </div>
                    <div className="form-group pr-5">
                        <label className="label w-100">
                            {t('controls.controlType')}
                        </label>
                        <SelectList
                            name="type"
                            className="select"
                            options={controlTypeOptions}
                            placeholder={t('controls.controlTypePlaceholder')}
                            isClearable={true}
                            errors={errors}
                        />
                    </div>


                    <div className="form-group pr-5">
                        <label className="label w-100">
                            {t('controls.controlFrequency')}
                        </label>
                        <SelectList
                            name="frequency"
                            className="select"
                            options={controlFrequencyOptions}
                            placeholder={t('controls.controlFrequencyPlaceholder')}
                            isClearable={true}
                            errors={errors}
                        />
                    </div>
                    <div className="form-group pr-5">
                        <label className="label w-100">
                            {t('controls.controlRatePlaceholder')}
                        </label>
                        <SelectList
                            name="controlAssessment"
                            className="select"
                            options={controlAssessmentOptions}
                            placeholder={t('controls.controlRatePlaceholder')}
                            isClearable={true}
                            errors={errors}
                        />
                    </div>
                    <div className="form-group pr-5">
                        <label className="label w-100">
                            {t('controls.department')}
                        </label>
                        <SelectInfinite
                          api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                          name="department"
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            className="department"
                            placeholder={t('risk-cosideration.search.organizedUnit')}
                            isClearable={true}
                        />
                    </div>
                    <FormatList
                        isValidType={isValidType}
                        value={['PDF', 'XLSX']}
                        parameterName="format"
                        onChange={(e) => setFormat2(e)}
                        isSubmitted={isSubmitted}
                        setSelectedFormat={(e) => setSelectedFormat(e.toLowerCase())}
                        setIsSubmitted={() => setIsSubmitted(false)}
                        error={!format2.length > 0}
                    />
                    <DownloadBtn
                        api={'reports/risks/controls-report'}
                        isDisabled={Object.keys(errors).length !== 0}
                        paramsLength={14}
                        setIsSubmitted={(e) => setIsSubmitted(e)}
                        documentName={`PDF`}
                        disableCheckingIfAllFilled={true}
                        apiParameters={{
                            format: format2,
                            ownerId: department !== null && department !== undefined ? `ownerId=${watch('department').value}` : "ownerId=",
                            startDate: validFrom !== null && validFrom !== undefined ? `startDate=${encodeURIComponent(format(validFrom, 'yyyy-MM-dd'))}` : 'startDate=',
                            endDate: validTo !== null && validTo !== undefined ? `endDate=${encodeURIComponent(format(validTo, 'yyyy-MM-dd'))}` : 'endDate=',
                            type: type !== null && type !== undefined ? `type=${type.value}` : 'type=',
                            purpose: purpose !== null && purpose !== undefined ? `purpose=${purpose.value}` : "purpose=",
                            frequency: frequency !== null && frequency !== undefined ? `frequency=${frequency.value}` : 'frequency=',
                            assessment: controlAssessment !== null && controlAssessment !== undefined ? `assessment=${controlAssessment.value}` : "assessment=",
                        }}
                    />
                </div>
            </div>
        </FormProvider>
    </div>);
};

export default ControlsReport;